//------------------------------------------------------------------------------
// メニュー状態 型定義
//------------------------------------------------------------------------------
// アクション種別
export default {

  // メニュー項目展開状態
  EXPANDED_ITEMS: 'UISTAT/EXPANDED_ITEMS',
};
